// extracted by mini-css-extract-plugin
export default {"link":"OO-z","disabled":"PO-z"};